const cleanFilter = (v, i, l) => (v[1] || 0) > 0 && v[0] != void 0 && v[0] != "undefined" && (v[0] || false);
const getBenched = (v, i, l) => [
  v[0],
  v[1].filter(
    (v2, i2, l2) => v2.datapoint == "home_substitutes" || v2.datapoint == "away_substitutes"
  ).length
];
const getPlayed = (v, i, l) => [
  v[0],
  v[1].filter(
    (v2, i2, l2) => v2.datapoint == "home_lineup" || v2.datapoint == "away_lineup"
  ).length
];
const getFouls = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "fouls").length
];
const getGameInfo = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "gameinfo")
  //.length,
];
const getGoals = (v, i, l) => {
  return [
    v[0],
    v[1].filter(
      (v2, i2, l2) => v2.datapoint == "incidents" && v2.incidentType == "goal" && v2?.incidentClass != "ownGoal"
    ).length || v[1].filter((v_, i2, l2) => v_.datapoint == "goals" && v[0] != "own-goal").length
  ];
};
const getYellowCards = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "yellowcards").length
];
const getTackles = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "tackle").length
];
const getShotsOnTarget = (v, i, l) => [
  v[0],
  v[1].filter(
    (v2, i2, l2) => v2.datapoint == "events" && v2.type == "shot-on-target"
  ).length
];
const getShots = (v, i, l) => [
  v[0],
  v[1].filter(
    (v2, i2, l2) => v2.datapoint == "events" && (v2.type == "shot" || v2.type == "shot-on-target")
  ).length
];
const getRedCards = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "redcards").length
];
const getPasses = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "pass").length
];
const getLostBalls = (v, i, l) => [
  v[0],
  v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "lost-ball").length
];
const getPassAccuracy = (v, i, l) => [
  v[0],
  (v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "pass").length < 20 ? 0 : v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "pass").length / (v[1].filter((v2, i2, l2) => v2.datapoint == "events" && v2.type == "pass").length + v[1].filter(
    (v2, i2, l2) => v2.datapoint == "events" && v2.type == "lost-ball"
  ).length)) * 100
];
function arrangebyplayer(obj, keysToEnumerate, idKeys, bygame = false, teamid, playerid) {
  let players = {};
  for (const game in obj) {
    const gameinfo = {
      datapoint: "gameinfo",
      againstid: teamid != obj[game].homeid ? obj[game].homeid : obj[game].awayid,
      against: teamid != obj[game].homeid ? obj[game].home : obj[game].away,
      loc: teamid == obj[game].homeid ? "H" : "A",
      date: obj[game].firststart ?? obj[game].start ?? obj[game]["patch_startTimestamp"],
      // date: obj[game].firststart,
      gameid: obj[game].id,
      id: game,
      hg: obj[game].goal_home ?? Object.values(obj[game].goals ?? {}).filter(
        (v, i, l) => v.team == "home"
      ).length,
      ag: obj[game].goal_away ?? Object.values(obj[game].goals ?? {}).filter(
        (v, i, l) => v.team == "away"
      ).length
    };
    if (!obj[game].test && game.slice(0, 4) != "test") {
      for (const p in keysToEnumerate) {
        const prop = keysToEnumerate[p];
        const idKey = idKeys[p];
        for (const player in obj[game][prop]) {
          const toput = {
            ...obj[game][prop][player],
            ...{ gameid: obj[game].id, datapoint: prop }
          };
          toput["idd"] = toput[idKey ?? "id"];
          if (playerid != void 0 && playerid != toput["idd"])
            continue;
          if (prop == "events" && idKey == "to" && toput.type == "shot-on-target" || prop == "events" && idKey == "to" && toput.type == "corner" || prop == "events" && idKey == "from" && toput.type == "corner-granted" || prop == "events" && idKey == "from" && toput.type == "penalty-granted" || prop == "events" && idKey == "from" && toput.type == "freekick-granted" || prop == "events" && idKey == "to" && toput.type == "shot" || prop == "events" && idKey == "to" && toput.type == "pass")
            continue;
          if (toput["idd"] == void 0 && ["events", "home_substitutes", "away_substitutes"].includes(prop))
            continue;
          if (prop == "events" && idKey == "to" && toput.type == "lost-ball")
            toput.type = "tackle";
          if (players[toput["idd"]] == void 0)
            players[toput["idd"]] = bygame ? {} : [];
          if (bygame) {
            if (players[toput["idd"]][game] == void 0)
              players[toput["idd"]][game] = [gameinfo];
            players[toput["idd"]][game].push(toput);
          } else
            players[toput["idd"]].push(toput);
        }
      }
    }
  }
  return players;
}
export {
  arrangebyplayer as a,
  getGameInfo as b,
  getPlayed as c,
  getBenched as d,
  getPassAccuracy as e,
  getPasses as f,
  getGoals as g,
  getLostBalls as h,
  getRedCards as i,
  getShots as j,
  getShotsOnTarget as k,
  getTackles as l,
  getYellowCards as m,
  getFouls as n,
  cleanFilter as o
};
